import { Component, type ErrorInfo } from 'react';
import type { WebappChatUIErrorBoundaryProps, WebappChatUIErrorBoundaryState } from './types';

class WebappChatUIErrorBoundary extends Component<
    WebappChatUIErrorBoundaryProps,
    WebappChatUIErrorBoundaryState
> {
    public state: WebappChatUIErrorBoundaryState = {
        hasError: false,
    };

    public static getDerivedStateFromError(): WebappChatUIErrorBoundaryState {
        return {
            hasError: true,
        };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Webapp Chat UI crashed during render:', error, errorInfo);
        this.props.onError?.(error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            return null;
        }

        return this.props.children;
    }
}

export default WebappChatUIErrorBoundary;
